import Breadcrumbs from "@/components/Breadcrumbs";
import { SettingsService } from "@/services/admin-services";
import { Software } from "@/services/global-services/models";
import { ArchiveBoxArrowDownIcon, XMarkIcon } from "@heroicons/react/24/outline";
import {
    Alert,
    Box,
    Button,
    Checkbox,
    CircularProgress,
    Collapse,
    Divider,
    Grid,
    IconButton,
    TextField,
    Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const breadcrumbs = [
    {
        to: "../../..",
        title: "Administration",
    },
    {
        title: "Settings",
        to: "../../..",
    },
    {
        title: "BIMQ Parameters",
        to: "..",
    },
];

const Details = () => {
    const [breadcrumbTrail, setBreadcrumbTrail] = useState(breadcrumbs);
    const [data, setData] = useState<Software>();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isSaving, setIsSaving] = useState<string>("");
    const [name, setName] = useState<string>("");
    const [isActive, setIsActive] = useState<boolean>(false);
    const [isDefaultActive, setIsDefaultActive] = useState<boolean>(false);
    const [isClassification, setIsClassification] = useState<boolean>(false);
    // const [color, setColor] = useState<string>("#e6f7f4");
    // const [invert, setIsInvert] = useState<boolean>(false);
    const [order, setOrder] = useState<number>(0);

    // const [file, setFile] = useState<File | null>(null);

    const [notification, setNotification] = useState<string>("");
    // const [active, setActive] = useState<boolean>(false);
    // const [checked, setChecked] = useState<boolean>(false);

    const notificationTimerRef = useRef<NodeJS.Timeout | null>(null);
    // const anchorRef = useRef<HTMLDivElement>(null);
    // const inputRef = useRef<HTMLInputElement>(null);

    const settingsService = new SettingsService("int");
    // const assetsService = useMemo(() => new AssetsService(), []);

    const navigate = useNavigate();
    const { identifier } = useParams();

    useEffect(() => {
        settingsService.getBimqParameters().then((data) => {
            setData(data.find((x) => x.id === identifier));
            setIsLoading(false);
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!data) return;
        setBreadcrumbTrail([...breadcrumbs, { title: `${data.bimQLabel}`, to: "" }]);
    }, [data]);

    useEffect(() => {
        if (!data) return;

        setName(data.name);
        setIsActive(data.active || false);
        setIsDefaultActive(data.defaultActive || false);
        setIsClassification(data.isClassification || false);
        // setIsInvert(data.invert || false);
        // setColor(data.color || "#e6f7f4");
        setOrder(data.order);
    }, [data]);

    useEffect(() => {
        if (!notification) return;

        notificationTimerRef.current = setTimeout(() => hideNotification(), 3000);
    }, [notification]);

    // useEffect(() => {
    //     if (!data) return;

    //     document.documentElement.style.setProperty(`--color-software-${data.id}`, color);

    //     let softwareStyle = document.getElementById(`style-software-${data.id}`);
    //     if (softwareStyle) document.getElementsByTagName("head")[0].removeChild(softwareStyle);

    //     softwareStyle = document.createElement("style");
    //     softwareStyle.id = `style-software-${data.id}`;
    //     softwareStyle.innerHTML = `
    //                     .software-${data.id} {
    //                         background-color: color-mix(in oklab, var(--color-software-${data.id}) 10%, transparent);
    //                         color: var(--color-software-${data.id});
    //                         &:is(:where(.group):has(*:checked) *) {
    //                             background-color: var(--color-software-${data.id});
    //                             color: white;
    //                         }
    //                     }

    //                     .software-${data.id}:hover {
    //                         background-color: color-mix(in oklab, var(--color-software-${data.id}) 90%, transparent);
    //                         color: white;
    //                     }

    //                     .software-${data.id}-selector {
    //                         border-color: rgba(0, 0, 0, 0.25);
    //                     }

    //                     .software-${data.id}-selector:hover {
    //                         border-color: rgba(0, 0, 0, 0.25);
    //                     }

    //                     .software-${data.id}-selected {
    //                         background-color: var(--color-software-${data.id});
    //                     }

    //                     ${
    //                         invert &&
    //                         `.software-${data.id} img{
    //                         &:is(:where(.group):has(*:checked) *) {
    //                         filter: invert(1);
    //                         }
    //                     }
    //                     .software-${data.id}:hover img {
    //                         filter: invert(1);
    //                     }`
    //                     }
    //                 `;

    //     document.getElementsByTagName("head")[0].appendChild(softwareStyle);
    // }, [color, invert]);

    const hideNotification = () => setNotification("");

    // const onFileInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    //     const { files } = event.target;
    //     if (!files) return;
    //     setFile(files[0]);
    // };

    // const onFileSelect = () => {
    //     if (!inputRef.current) return;
    //     inputRef.current.click();
    // };

    const onCancel = () => navigate("..");

    const onSaveLabel = async () => {
        if (!data) return;

        setIsSaving("name");

        // if (file) {
        //     const form = new FormData();
        //     form.append("Name", `discipline-icon-${data.id}`);
        //     form.append("File", file);

        //     const result = await assetsService.create(form);
        //     data.icon = result.file.url;
        // }

        settingsService
            .updateBimqParameters(data.id, {
                ...data,
                name,
                // invert,
                // color,
            })
            .then((result) => {
                setData({ ...result, name: result.name });
                setNotification("name");
                setIsSaving("");
            });
    };

    const onSaveSettings = () => {
        if (!data) return;

        setIsSaving("settings");

        settingsService
            .updateBimqParameters(data.id, {
                ...data,
                active: isActive,
                isClassification: isClassification,
                defaultActive: isDefaultActive,
                order,
            })
            .then((result) => {
                setData({ ...result, name: result.name });
                setNotification("settings");
                setIsSaving("");
            });
    };

    if (isLoading || !data)
        return (
            <Box>
                <Breadcrumbs trail={breadcrumbs} />

                <Divider />
                <Box m={4} sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 500 }}>
                    <CircularProgress />
                </Box>
            </Box>
        );

    return (
        <Box>
            <Breadcrumbs trail={breadcrumbTrail} />

            <Divider />

            <Box m={4} sx={{ display: "flex" }}>
                <Box sx={{ display: "flex", flex: 1, flexDirection: "column" }}>
                    <Typography variant={"h4"}>{data.bimQLabel}</Typography>
                </Box>
            </Box>

            <Divider />

            <Grid container spacing={2} p={{ xs: 2, md: 4 }}>
                <Box sx={{ width: "100%" }}>
                    <Collapse in={notification === "name"}>
                        <Alert
                            action={
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => hideNotification()}
                                >
                                    <XMarkIcon className="w-5 h-5" />
                                </IconButton>
                            }
                            severity={"success"}
                        >
                            Name updated successfully.
                        </Alert>
                    </Collapse>
                </Box>

                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography variant="h6" gutterBottom fontWeight={700}>
                        Label
                    </Typography>
                    <Typography variant="subtitle2" color={"text.secondary"}>
                        Configure parameter label.
                    </Typography>
                </Grid>

                <Grid size={{ xs: 12, md: 8 }}>
                    <Grid container spacing={4}>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <TextField
                                label="Parameter label"
                                variant="outlined"
                                fullWidth
                                value={name}
                                onChange={(e) => setName(e.currentTarget.value)}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                {/* 
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Typography variant="h6" gutterBottom fontWeight={700}>
                                Button
                            </Typography>
                            <Typography variant="subtitle2" color={"text.secondary"}>
                                Configure software button appearance.
                            </Typography>
                        </Grid>

                        <Grid container size={{ xs: 12, md: 8 }} rowSpacing={2}>
                            <input
                                value=""
                                style={{ visibility: "hidden", opacity: 0, height: 0, width: 0 }}
                                ref={inputRef}
                                type="file"
                                accept="image/*"
                                onChange={onFileInputChange}
                            />
                            <Grid size={{ xs: 4 }}>
                                <Box
                                    ref={anchorRef}
                                    sx={{ width: "100%", position: "relative" }}
                                    onClick={() => {
                                        setActive(true);
                                    }}
                                >
                                    {active ? (
                                        <ClickAwayListener onClickAway={() => setActive(false)}>
                                            <Popper open={active} anchorEl={anchorRef.current} placement="bottom-start">
                                                <Box
                                                    className="color-picker-overlay"
                                                    sx={{
                                                        position: "absolute",
                                                        zIndex: 99999,
                                                        top: "calc(100% + 5px)",
                                                        left: 1,
                                                    }}
                                                >
                                                    <Box
                                                        className="color-picker-background"
                                                        sx={{
                                                            position: "fixed",
                                                            top: 0,
                                                            left: 0,
                                                            width: "100%",
                                                            height: "100%",
                                                            cursor: "pointer",
                                                        }}
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            setActive(false);
                                                        }}
                                                    />
                                                    <ChromePicker
                                                        color={color}
                                                        onChange={(color: ColorResult) => {
                                                            setColor(color.hex);
                                                        }}
                                                    />
                                                </Box>
                                            </Popper>
                                        </ClickAwayListener>
                                    ) : null}
                                    <TextField
                                        variant="outlined"
                                        fullWidth
                                        label="Software color"
                                        value={color || ""}
                                        InputProps={{
                                            disableUnderline: true,
                                            startAdornment: (
                                                <InputAdornment
                                                    position="start"
                                                    sx={{
                                                        mt: "2px",
                                                        mr: "8px",
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            position: "relative",
                                                            display: "inline-block",
                                                            height: "0.75rem",
                                                            width: "0.75rem",
                                                            borderRadius: "100%",
                                                        }}
                                                        style={{
                                                            background: color,
                                                        }}
                                                    />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Box>
                            </Grid>
                            <Grid size={{ xs: 6 }}>
                                <Box sx={{ display: "flex" }}>
                                    <Box>
                                        <Checkbox
                                            checked={invert}
                                            onChange={(e) => setIsInvert(e.target.checked)}
                                            disableRipple
                                        />
                                    </Box>
                                    <Box sx={{ flex: 1, pt: "10px" }}>
                                        <Typography variant={"subtitle2"} fontWeight={700}>
                                            Invert
                                        </Typography>
                                        <Typography variant={"caption"}>
                                            Determine if the color of the logo should be inverted when hovering over the
                                            button and when the selection would be active.
                                        </Typography>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid size={{ xs: 2 }}>
                                <Button variant="outlined" onClick={onFileSelect}>
                                    Change icon
                                </Button>
                            </Grid>
                            <Grid size={{ xs: 12 }}>
                                <div key={data.id} className="group">
                                    <div
                                        className={clsx([
                                            "flex flex-wrap rounded-md text-base font-medium items-center cursor-pointer",
                                            "min-h-[90px] gap-3 p-5",
                                            // "hover:bg-primary-600 hover:text-white",
                                            // "group-has-checked:bg-primary-500 group-has-checked:text-white",

                                            `software-${data.id}`,
                                            "hover:text-white group-has-checked:text-white",
                                        ])}
                                        onClick={() => setChecked((x) => !x)}
                                    >
                                        <div className="grid size-6 grid-cols-1 flex-shrink-0">
                                            <input
                                                id={"preview"}
                                                name={"preview"}
                                                value={data.id}
                                                checked={checked}
                                                onClick={() => setChecked((x) => !x)}
                                                type="radio"
                                                className={clsx([
                                                    " cursor-pointer col-start-1 row-start-1 appearance-none rounded-full border-2 min-w-6 min-h-6",
                                                    "checked:outline-2 checked:-outline-offset-4",
                                                    `border-black/25 bg-transparent group-hover:border-white/25 checked:border-white/25 checked:outline-transparent`,
                                                ])}
                                            />
                                            <div className="pointer-events-none opacity-0 group-has-checked:opacity-100 bg-white w-4 h-4 rounded-full col-start-1 row-start-1 self-center justify-self-center" />
                                            <div
                                                className={clsx([
                                                    "pointer-events-none opacity-0 group-has-checked:opacity-100  w-3 h-3 rounded-full col-start-1 row-start-1 self-center justify-self-center",
                                                    `software-${data.id}-selected`,
                                                ])}
                                            />
                                        </div>
                                        {(data.icon || file) && (
                                            <div className="shrink-0">
                                                <img
                                                    src={file ? URL.createObjectURL(file) : data.icon!}
                                                    alt={data.name}
                                                    className={clsx(["h-[50px]", "w-auto"])}
                                                />
                                            </div>
                                        )}
                                        {name}
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                */}

                <Grid size={{ xs: 12 }} sx={{ display: "flex", alignContent: "flex-end" }}>
                    <Button
                        variant="contained"
                        color="error"
                        sx={{ ml: "auto" }}
                        onClick={() => onCancel()}
                        disabled={Boolean(isSaving)}
                    >
                        Cancel
                    </Button>
                    <Box sx={{ ml: 1, position: "relative" }}>
                        <Button
                            variant="contained"
                            startIcon={<ArchiveBoxArrowDownIcon className="w-5 h-5" />}
                            sx={{ ml: 1 }}
                            onClick={() => onSaveLabel()}
                            disabled={Boolean(isSaving)}
                        >
                            Save
                        </Button>
                        {isSaving === "name" && (
                            <CircularProgress
                                size={24}
                                sx={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    marginTop: "-12px",
                                    marginLeft: "-12px",
                                }}
                            />
                        )}
                    </Box>
                </Grid>
            </Grid>

            <Divider />

            <Grid container spacing={2} p={{ xs: 2, md: 4 }}>
                <Box sx={{ width: "100%" }}>
                    <Collapse in={notification === "settings"}>
                        <Alert
                            action={
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => hideNotification()}
                                >
                                    <XMarkIcon className="w-5 h-5" />
                                </IconButton>
                            }
                            severity={"success"}
                        >
                            Settings updated successfully.
                        </Alert>
                    </Collapse>
                </Box>

                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography variant="h6" gutterBottom fontWeight={700}>
                        Settings
                    </Typography>
                    <Typography variant="subtitle2" color={"text.secondary"}>
                        Additional configuration.
                    </Typography>
                </Grid>

                <Grid size={{ xs: 12, md: 8 }}>
                    <Grid container spacing={4}>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <Box sx={{ display: "flex" }}>
                                <Box>
                                    <Checkbox
                                        checked={isActive}
                                        onChange={(e) => setIsActive(e.target.checked)}
                                        disableRipple
                                    />
                                </Box>
                                <Box sx={{ flex: 1, pt: "10px" }}>
                                    <Typography variant={"subtitle2"} fontWeight={700}>
                                        Active
                                    </Typography>
                                    <Typography variant={"caption"}>
                                        Determine if the parameter is displayed in the applicable list to the end-user.
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>

                        <Grid size={{ xs: 12, sm: 6 }} className="opacity-50 pointer-events-none">
                            <Box sx={{ display: "flex" }}>
                                <Box>
                                    <Checkbox
                                        checked={isDefaultActive}
                                        onChange={(e) => setIsDefaultActive(e.target.checked)}
                                        disableRipple
                                    />
                                </Box>
                                <Box sx={{ flex: 1, pt: "10px" }}>
                                    <Typography variant={"subtitle2"} fontWeight={700}>
                                        Default active
                                    </Typography>
                                    <Typography variant={"caption"}>
                                        Determine if the software is automatically selected when the user views an
                                        element for the first time.
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>

                        <Grid size={{ xs: 12, sm: 6 }}>
                            <Box sx={{ display: "flex" }}>
                                <Box>
                                    <Checkbox
                                        checked={isClassification}
                                        onChange={(e) => setIsClassification(e.target.checked)}
                                        disableRipple
                                    />
                                </Box>
                                <Box sx={{ flex: 1, pt: "10px" }}>
                                    <Typography variant={"subtitle2"} fontWeight={700}>
                                        Is classification system?
                                    </Typography>
                                    <Typography variant={"caption"}>
                                        Determine if the parameter is displayed as a classification system.{" "}
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>

                        <Grid size={{ xs: 12, sm: 12 }}>
                            <Typography variant={"subtitle2"} sx={{ mb: 2 }} fontWeight={700}>
                                Order
                            </Typography>
                            <TextField
                                label="Order"
                                type="number"
                                variant="outlined"
                                fullWidth
                                value={order}
                                disabled={Boolean(isSaving)}
                                onChange={(e) => setOrder(parseInt(e.currentTarget.value))}
                            />
                        </Grid>

                        <Grid size={{ xs: 12 }} sx={{ display: "flex", alignContent: "flex-end" }}>
                            <Button
                                variant="contained"
                                color="error"
                                sx={{ ml: "auto" }}
                                onClick={() => onCancel()}
                                disabled={Boolean(isSaving)}
                            >
                                Cancel
                            </Button>
                            <Box sx={{ ml: 1, position: "relative" }}>
                                <Button
                                    variant="contained"
                                    startIcon={<ArchiveBoxArrowDownIcon className="w-5 h-5" />}
                                    sx={{ ml: 1 }}
                                    onClick={() => onSaveSettings()}
                                    disabled={Boolean(isSaving)}
                                >
                                    Save
                                </Button>
                                {isSaving === "settings" && (
                                    <CircularProgress
                                        size={24}
                                        sx={{
                                            position: "absolute",
                                            top: "50%",
                                            left: "50%",
                                            marginTop: "-12px",
                                            marginLeft: "-12px",
                                        }}
                                    />
                                )}
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
};

export default Details;
